var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIlluStatusCloud(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 132.887,
    height: 151,
    viewBox: "0 0 132.887 151",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Combined-Shape",
    x: 70.289,
    y: 33.437,
    width: 48.183,
    height: 36.16,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#0057ff",
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Combined-Shape-2",
    x: 27.059,
    y: 30.001,
    width: 70.789,
    height: 66.11,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#0057ff",
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Combined-Shape-3",
    x: 12.146,
    y: 65.75,
    width: 52.308,
    height: 60.007,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#0057ff",
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Shape",
    x: 29.124,
    y: 39.486,
    width: 93.853,
    height: 87.702,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#0057ff",
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3843",
    "data-name": "Gruppe 3843",
    transform: "translate(-557 -244.419)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vereinigungsmenge_4",
    "data-name": "Vereinigungsmenge 4",
    d: "M-2713.677-546.674l.4-.235-1.278-75.256,66.527-38.7,66.36,38.7v76l-66.36-38.7h0l65.485,38.195-65.486,36.8Z",
    transform: "translate(3271.553 905.289)",
    fill: "#0057ff",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(860.147 244.42)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-26",
    transform: "translate(-281 37)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cloud"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -22.15, -37)",
    filter: "url(#Combined-Shape)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape-4",
    "data-name": "Combined-Shape",
    d: "M68.3,3.9l.17.1.051.034L86.066,13.9l0,.012a6.276,6.276,0,0,0-2.573-.6H83.37a3.283,3.283,0,0,0-.349.019s-8.319,1.865-9,5.426a2.05,2.05,0,0,1-.127.486l-.1-.055c-.327-.861-.985-7.877-7.629-9.4l.074.017L59.374,6.249l-.312-.177a21.775,21.775,0,0,1,6.081-2.451A4.39,4.39,0,0,1,68.3,3.9Z",
    transform: "translate(22.15 37)",
    fill: "none",
    stroke: "#0057ff",
    strokeWidth: 2,
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -22.15, -37)",
    filter: "url(#Combined-Shape-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape-5",
    "data-name": "Combined-Shape",
    d: "M48.638.246l.278.062,4.465,2.536,5.993,3.4L66.242,9.8a15.8,15.8,0,0,0-7.414.3c-15.874,3.9-26.23,28.484-26.57,35.775,0,0-.1.037-.292.114L14.95,35.869c.426-6.5,8.238-25.557,20.553-33.046l.431-.257A20.757,20.757,0,0,1,41.51.613,16.129,16.129,0,0,1,48.638.246Z",
    transform: "translate(22.15 37)",
    fill: "none",
    stroke: "#0057ff",
    strokeWidth: 2,
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -22.15, -37)",
    filter: "url(#Combined-Shape-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape-6",
    "data-name": "Combined-Shape",
    d: "M15.28,35.869l16.988,9.824q-.006.1-.011.189a15.133,15.133,0,0,0-1.445.635l-.293.147A24.45,24.45,0,0,0,16.978,69.111c0,3.621,1.291,5.653,2.953,6.767l-.054-.03-6.106-3.6-.613-.362L2.129,65.37C.883,64.16,0,62.257,0,59.267,0,43.794,12.268,37.2,15.28,35.869Z",
    transform: "translate(22.15 37)",
    fill: "none",
    stroke: "#0057ff",
    strokeWidth: 2,
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -22.15, -37)",
    filter: "url(#Shape)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    d: "M27.164,76.91l52.8-29.841S90.83,37.744,90.83,25.028s-7.81-11.7-7.81-11.7-8.319,1.865-9,5.426S74.7,6.208,58.827,10.108,32.6,38.592,32.257,45.882a24.573,24.573,0,0,0-15.28,23.228C16.978,79.284,27.164,76.91,27.164,76.91Z",
    transform: "translate(22.15 37)",
    fill: "none",
    stroke: "#0057ff",
    strokeWidth: 2,
    fillRule: "evenodd"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIlluStatusCloud);
export default __webpack_public_path__ + "static/media/illu-status-cloud.b3e7dd9bc98a606f8234e2c4f4c2286e.svg";
export { ForwardRef as ReactComponent };